import 'regenerator-runtime/runtime'

import './main'
